<template>

    <v-dialog v-model="show" persistent max-width="400" :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? $store.commit('closeConfirmModal') : null}">
        <v-card>
            <v-card-title class="headline" :style="{color: titleColor}">
                <v-icon class="mr-3" color="#DC3545" v-if="$store.state.confirmModal.type == 'error'">mdi-alert</v-icon>
                <v-icon class="mr-3" color="#FB8C00" v-if="$store.state.confirmModal.type == 'warning'">mdi-alert</v-icon>
                <v-icon class="mr-3" color="#2980B9" v-if="$store.state.confirmModal.type == 'update'">mdi-arrow-down-circle</v-icon>
                {{$store.state.confirmModal.title}}
            </v-card-title>

            <v-card-text v-html="$store.state.confirmModal.message">
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn v-if="!$store.state.confirmModal.hideCancel" :color="cancelButtonColor" text @click="cancelAction">Cancel</v-btn>
                <v-btn :color="confirmButtonColor" text @click="confirmAction">{{confirmButtonText}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    name: 'Confirm',
    props: {
        value: Boolean,
    },
    data: () => ({
        titleColor: '#FFFFFF',
        cancelButtonColor: '#FFFFFF',
        confirmButtonColor: '#FFFFFF',
        attach: '#telsasoft-application'
    }),

    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
            }
        },

        confirmButtonText() {
            if(this.$store.state.confirmModal.type == 'delete') {
                return 'Delete';
            }
            else {
                return 'Ok';
            }
        }
    },

    methods: {
        confirmAction: function() {
            this.$store.state.confirmModal.confirmAction();
            this.$store.commit('closeConfirmModal');
        },

        cancelAction: function() {
            this.$store.state.confirmModal.cancelAction();
            this.$store.commit('closeConfirmModal');
        },

        setColors: function() {
            if(this.$store.state.confirmModal.type == 'warning') {
                this.titleColor = '#FB8C00';
                this.cancelButtonColor = '#FFFFFF';
                this.confirmButtonColor = '#FB8C00';
            }
            else if(this.$store.state.confirmModal.type == 'error') {
                this.titleColor = '#DC3545';
                this.cancelButtonColor = '#FFFFFF';
                this.confirmButtonColor = '#DC3545';
            }
            else if(this.$store.state.confirmModal.type == 'delete') {
                this.titleColor = '#FFFFFF';
                this.cancelButtonColor = '#FFFFFF';
                this.confirmButtonColor = '#DC3545';
            }
            else {
                this.titleColor = '#FFFFFF';
                this.cancelButtonColor = '#FFFFFF';
                this.confirmButtonColor = '#FFFFFF';
            }
        }
    },

    watch: {
        show: {
            handler(newVal, oldVal) {
                this.setColors();
            },
        },
    },

    mounted() {
        this.setColors();
    },
  
};
</script>

<style scoped>

    .headline {
        color: "#D8000C";
    }
    
</style>

